const TermsViewer = ()=> {
  const totalPages = 6; // number of images you have

  const pages = Array.from({ length: totalPages }, (_, i) =>
    `/severnet-user-agreement/${i + 1}.jpg`
  );

  return (
    <div
      style={{
        height:'100%',
        overflow: "scroll",
      }}
    >
      {pages.map((src, index) => (
        <img
          key={index}
          src={src}
          alt={`Terms page ${index + 1}`}
          style={{
            width: "100%",
            display: "block",
          }}
        />
      ))}
    </div>
  );
}
export default TermsViewer